import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition} from 'helpers/css';
import DotSummary, {DotSummaryScale} from 'components/DotSummary';

export interface GraphTooltipProps {
  header: string;
  items: GraphTooltipItem[];
}

export interface GraphTooltipItem {
  title: string;
  dotColor: string;
  value: string | number;
}

export const Container = styled.div`
  width: max-content;
  min-width: 106px;
  border-radius: 5px;
  color: ${({theme}) => theme.colors.primary};
  border: 1px solid ${({theme}) => theme.variables.tableBorderColor};
  background-color: ${({theme}) => theme.variables.accentBackgroundColor};
  box-shadow: 3px 10px 24px rgba(25, 25, 27, .5);
  box-sizing: border-box;
  cursor: pointer;

  ${transition()};

  &:hover {
    background: ${({theme}) => transparentize(
      .95,
      theme.colors.white)};
  }

  &:active {
    background: ${({theme}) => transparentize(
      .90,
      theme.colors.white)};
  }
`;

const Header = styled.div`
  color: white;
  text-align: center;
  padding: 5px;
  border-bottom: 1px solid ${({theme}) => theme.variables.tableBorderColor};

  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 13px;
  letter-spacing: 0.01em;

`;

const Content = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px;
  color: white;
`;

/**
 * The function render Graph Tooltip
 * @param {CategoryProps} props
 * @constructor
 */
export default function GraphTooltip(props: GraphTooltipProps) {
  /**
   * The function render Graph Tooltip items
   * @return {React.ReactNodeArray}
   * @constructor
   */
  function renderItems() {
    return props.items.map((item, index) => (
      <DotSummary
        key={index + item.title}
        title={item.title}
        value={item.value}
        dotColor={item.dotColor}
        scale={DotSummaryScale.Small}
      />
    ));
  }

  return (
    <Container>
      <Header>{props.header}</Header>
      <Content>
        {renderItems()}
      </Content>
    </Container>
  );
}
